import { expEmail } from "@utils/expression";
export class Rules {
  constructor(translate) {
    this.translate = translate;
  }

  email() {
    return {
      type: "text",
      placeholder: this.translate("email"),
      messageError: this.translate("invalid_email"),
      className: "input-blue text-dark w-100 p-4 border fw-light ",
      size: "md",
      rules: {
        required: this.translate("mandatory"),
        pattern: {
          value: expEmail,
          message: this.translate("invalid_format"),
        },
      },
    };
  }

  fullName() {
    return {
      type: "text",
      placeholder: this.translate("name"),
      messageError: this.translate("name_is__required"),
      className: "input-blue text-dark w-100 p-4 border fw-light ",
      size: "md",
      rules: {
        required: this.translate("mandatory"),
      },
    };
  }

  phone() {
    return {
      type: "text",
      placeholder: this.translate("phone"),
      messageError: this.translate("phone_is_required"),
      className: "input-blue text-dark w-100 p-4 border fw-light ",
      size: "md",
      rules: {
        required: this.translate("mandatory"),
      },
    };
  }

  address() {
    return {
      type: "text",
      placeholder: this.translate("address"),
      messageError: this.translate("address_is_required"),
      className: "input-blue text-dark w-100 p-4 border fw-light ",
      size: "md",
      rules: {
        required: this.translate("mandatory"),
      },
    };
  }

  password() {
    return {
      type: "password",
      messageError: this.translate("password_required"),
      placeholder: this.translate("password"),
      className: "input-blue text-dark w-100 p-4 border fw-light ",
      size: "md",
      rules: {
        required: this.translate("mandatory"),
      },
    };
  }

  card() {
    return {
      type: "text",
      placeholder: this.translate("NNNN NNNN NNNN NNNN"),
      messageError: this.translate("card_invalid"),
      className: "input-blue text-dark w-100 p-4 border fw-light ",
      size: "md",
      rules: {
        required: this.translate("mandatory"),
      },
    };
  }

  cvv() {
    return {
      type: "text",
      placeholder: this.translate("cvv"),
      messageError: this.translate("cvv_invalid"),
      className: "input-blue text-dark w-100 p-4 border fw-light ",
      size: "md",
      rules: {
        required: this.translate("mandatory"),
      },
    };
  }

  cardType() {
    return {
      type: "text",
      placeholder: this.translate("card type"),
      messageError: this.translate("card_type_invalid"),
      className: "input-blue text-dark w-100 p-4 border fw-light ",
      size: "md",
      rules: {
        required: this.translate("mandatory"),
      },
    };
  }

  expirationDate() {
    return {
      type: "text",
      placeholder: this.translate("expiration date"),
      messageError: this.translate("expiration_date_invalid"),
      className: "input-blue text-dark w-100 p-4 border fw-light ",
      size: "md",
      rules: {
        required: this.translate("mandatory"),
      },
    };
  }
}
